import generateUUID from './generate-uuid';

export default function generateSpdsElementId(id, idBase = 'spds-component') {
  return id || `${idBase}-${generateUUID()}`;
}
